"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardDisclosure = void 0;
class CardDisclosure {
    constructor(disclosureStatus, cardId) {
        this.disclosureStatus = disclosureStatus;
        this.cardId = cardId;
    }
    clone() {
        return new CardDisclosure(this.disclosureStatus, this.cardId);
    }
}
exports.CardDisclosure = CardDisclosure;
